import { __assign, __extends, __rest } from "tslib";
import React, { Component } from "react";
import { View, Text } from "react-native";
import PropTypes from "prop-types";
import styles from "./PnmacTable.styles.js";
var PnmacCell = /** @class */function (_super) {
  __extends(PnmacCell, _super);
  function PnmacCell() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacCell.prototype.render = function () {
    var _a = this.props,
      data = _a.data,
      width = _a.width,
      height = _a.height,
      flex = _a.flex,
      style = _a.style,
      textStyle = _a.textStyle,
      borderStyle = _a.borderStyle,
      props = __rest(_a, ["data", "width", "height", "flex", "style", "textStyle", "borderStyle"]);
    var textDom = /*#__PURE__*/React.isValidElement(data) ? data : (/*#__PURE__*/React.createElement(Text, __assign({
      style: [textStyle, styles.text]
    }, props), data));
    var borderTopWidth = borderStyle && borderStyle.borderWidth || 0;
    var borderRightWidth = borderTopWidth;
    var borderColor = borderStyle && borderStyle.borderColor || "#000";
    return /*#__PURE__*/React.createElement(View, {
      style: [{
        borderTopWidth: borderTopWidth,
        borderRightWidth: borderRightWidth,
        borderColor: borderColor
      }, styles.cell, width && {
        width: width
      }, height && {
        height: height
      }, flex && {
        flex: flex
      }, !width && !flex && !height && !style && {
        flex: 1
      }, style],
      nativeID: props.idTag1
    }, textDom);
  };
  return PnmacCell;
}(Component);
export default PnmacCell;